<template>
  <header >

    <div v-if="post.data.body1[0]" class="video-header">
      <content-video :video="post.data.body1[0]" />
      <p class="post-meta__category" v-html="category"></p>
      <transition name="block" appear>
        <h1 id="video-article" class="post-title reveal-text" :key="`${post.uid}-title`" >{{title}}</h1>
      </transition>
    </div>

    <div v-else class="image-header">
      <img class="post-image" :src="post.data.featured_image.url" :alt="post.data.featured_image.alt" :width="post.data.featured_image.width" :height="post.data.featured_image.height">
      <p class="post-meta__category" v-html="category"></p>
      <transition name="block" appear>
        <h1 class="post-title reveal-text" :key="`${post.uid}-title`" >{{title}}</h1>
      </transition>
    </div>
  </header>
</template>

<script>
import PrismicDOM from 'prismic-dom'
import ContentVideo from '@/components/content/Video'

export default {
  name: 'article-header',
  components: {
    ContentVideo
  },
  props: ['post'],
  computed: {
    title () {
      return this.post ? PrismicDOM.RichText.asText(this.post.data.title) : null
    },
    url () {
      return location.href // this.$route.fullPath
    },
    category () {
      return this.post ? this.post.data.category : 'No Category'
    }
  },
  methods: {
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    getHtmlContent (str) {
      return str ? PrismicDOM.RichText.asHtml(str) : ''
    },
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 72px;
  font-weight: 700;
}

h2 {
  font-size: 36px;
  font-weight: 700;
}

h3 {
  font-size: 22px;
  font-weight: 700;
}

.post-title {
  border-top: 1px solid #fff;
  font-size: 2rem;
  margin-bottom: 2rem;
  margin-top: 0;
  padding: 3rem 1rem 0;
  text-transform: uppercase;

  @media (min-width: $breakpoint-lg) {
    font-size: 4rem;
    max-width: 68%;
  }
}

.post-image {
  width: 100%;
  height: auto;
  max-height: 30vh;
  //height:100%;
  object-fit: contain;
  margin-bottom: 2em;

  @media (min-width: $breakpoint-md) {
    max-height: 40vh;
  }

  @media (min-width: $breakpoint-lg) {
    max-height: 50vh;
  }
}

header {
  text-align: center;
  color: #fff;
  background-color: $blue;
  padding: 1rem 0;

  // .reveal-text:after {
  //   background-color: $green;
  // }
}

header.leadership {
  background-color: $leadership;

  // .reveal-text:after {
  //   background-color: $purple;
  // }
}

header.legal-market {
  background-color: $legal-market;

  // .reveal-text:after {
  //   background-color: $teal;
  // }
}

header.legal-tech {
  background-color: $legal-tech;

  // .reveal-text:after {
  //   background-color: $orange;
  // }
}

header.management {
  background-color: $management;

  // .reveal-text:after {
  //   background-color: $green;
  // }
}

.post-meta__category {
  display: inline;
  font-style: italic;
  margin-bottom: 0;
  margin-left: 15px;
  text-transform: uppercase;
  position: relative;
  margin: 0 auto;

  &::before {
    background-color: #fff;
    content: "";
    display: block;
    height: 12px;
    left: -30px;
    position: absolute;
    transform: rotate(-45deg);
    top: 3px;
    width: 12px;
  }

  &::after {
    background-color: #fff;
    content: "";
    display: block;
    height: 40px;
    margin: 10px auto 0;
    width: 1px;
  }
}

// Example title transition / animation
.reveal-text,
.reveal-text::after {
  animation-delay: .4s;
  animation-iteration-count: 1;
  animation-duration: .8s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.0, 0.0, 0.2, 1);
}

.reveal-text {
  position: relative;
  display: inline-block;
  user-select: none;
  animation-name: reveal-text;
  color: #FFF;
  cursor: default;

  // &::after {
  //   content: "";
  //   position: absolute;
  //   z-index: z('reveal-text');
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   background-color: #000;
  //   transform: scaleX(0);
  //   transform-origin: 0 50%;
  //   pointer-events: none;
  //   animation-name: revealer-text;
  // }
}


@keyframes reveal-text {
  from {
    clip-path: inset(0 100% 0 0);
  }

  to {
    clip-path: inset(0 0 0 0);
  }
}


@keyframes revealer-text {
  0%, 50% {
    transform-origin: 0 50%;
  }

  60%, 100% {
    transform-origin: 100% 50%;
  }

  60% {
    transform: scaleX(1);
  }

  100% {
    transform: scaleX(0);
  }
}
</style>



// WEBPACK FOOTER //
// ArticleHeader.vue?836d844c